import React from 'react';
import { NavLink } from 'react-router-dom';

const Logo = () => {
    return(
        <div className="logo">
            <NavLink to='/' rel="noreferrer">
                <img src={'api/welsend/public/siteLogo/file'} alt="welsend_logo" referrerPolicy="no-referrer"/>
            </NavLink>
        </div>
    )
}

export default Logo;